# Progress Bar
# =============
Backbone = require 'backbone'
Backbone.$ = $

class SupportProgressBarView extends Backbone.View
  tagName: 'ol'
  className: 'steps'

  initialize: ->
    @I18nScope = 'modules.support'

  render: ->
    x = 1
    if Groupon.Support.MAXINDEX is undefined
      Groupon.Support.MAXINDEX = 0

    until x > Groupon.Support.MAXINDEX
      if x <= Groupon.Support.CURRENTVIEW.id
        @$el.append("<li class='active'><a class = 'progressBar' href='javascript:;'>#{x}</a></li>")
      else
        @$el.append("<li><a class = 'progressBar' href='javascript:;'>#{x}</a></li>")
      ++x

module.exports = SupportProgressBarView
